<template>
  <v-card class="pa-4">
    <v-card-title class="d-flex align-center justify-space-between pb-2 v-card-title">
      <div class="d-flex align-center">
        <v-icon left medium class="mr-2 text-color">fa-solid fa-hashtag</v-icon>
        <span class="text-h6 font-weight-bold text-color">
          {{ $t("views.settings.config_trip_number") }}
        </span>
      </div>
    </v-card-title>

    <v-divider class="secondary mb-4" />
    <v-card-text>
      <p class="mb-6">
        {{ $t("views.settings.config_trip_number_description") }}
      </p>

      <v-row dense>
        <v-col cols="12" md="4">
          <v-text-field v-model="formData.header" :label="$t('views.settings.config_trip_number_header')" outlined dense
            :rules="[v => v.length <= 10 || $t('views.settings.error_max_characters', { max: 10 })]" counter="10"
            placeholder="Ej: OS" />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="formData.alphanumericPrefix"
            :label="$t('views.settings.config_trip_number_alphanumericPrefix')" outlined dense
            :rules="[v => v.length <= 10 || $t('views.settings.error_max_characters', { max: 10 })]" counter="10"
            placeholder="Ej: AAAA" />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field v-model="formData.alphanumericSuffix"
            :label="$t('views.settings.config_trip_number_alphanumericSuffix')" outlined dense
            :rules="[v => v.length <= 30 || $t('views.settings.error_max_characters', { max: 30 })]" counter="30"
            placeholder="Ej: 000001" />
        </v-col>
      </v-row>

      <v-divider class="my-4" />

      <v-row dense class="mb-4">
        <v-col cols="12" md="6">
          <v-card outlined class="pa-3">
            <v-card-title class="subtitle-2 font-weight-bold mb-2">
              <v-icon left class="mr-2" color="primary">fa-solid fa-gear</v-icon>
              {{ $t("views.settings.config_trip_number_preview") }}
            </v-card-title>
            <v-card-text class="text-h6">
              {{ formData.fullTripNumber || $t("views.settings.config_trip_number_invalid_preview") }}
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card outlined class="pa-3">
            <v-card-title class="subtitle-2 font-weight-bold mb-2">
              <v-icon left class="mr-2" color="success">fa-solid fa-location-arrow</v-icon>
              {{ $t("views.settings.config_trip_number_current") }}
            </v-card-title>
            <v-card-text class="text-h6">
              {{ tripNumber || $t("views.settings.config_trip_number_not_generated") }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <div class="d-flex justify-end">
        <v-btn @click="saveConfig" color="light-green darken-3" class="white--text">
          <v-icon small class="fa-solid fa-bookmark mr-1" />
          {{ $t("views.settings.save") }}
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  getLastTripNumberConfig,
  getTripNumber,
  saveTripNumberConfig,
  getLastTripNumber
} from "@/components/views/Settings/ConfigTripNumber/Services/useTripNumberConfig";

export default {
  name: "ConfigTripNumber",
  data() {
    return {
      formData: {
        header: '',
        alphanumericPrefix: '',
        alphanumericSuffix: '',
        fullTripNumber: '',
      },
      tripNumber: '',
    };
  },
  methods: {
    async loadTripNumberActual() {
      try {
        const config = await getLastTripNumberConfig(this.axios);
        if (config) {
          this.tripNumber = config.fullTripNumber;
        } else {
          console.warn("No config data found for trip number");
        }
      } catch (error) {
        console.error("Error loading current trip number:", error);
      }
    },
    async loadConfigTrip() {
      try {
        const config = await getLastTripNumber(this.axios);
        if (config) {
          this.tripNumber = config.fullTripNumber;
        } else {
          console.warn("No config data found for trip number");
        }
      } catch (error) {
        console.error("Error loading current trip number:", error);
      }
    },
    async loadTripNumberConfig() {
      try {
        const config = await getTripNumber(this.axios);
        if (config) {
          this.formData = {
            header: config.header || '',
            alphanumericPrefix: config.alphanumericPrefix || '',
            alphanumericSuffix: config.alphanumericSuffix || '',
            fullTripNumber: config.fullTripNumber || ''
          };
        } else {
          console.warn("No config data found for trip number");
        }
      } catch (error) {
        console.error("Error loading trip number config:", error);
      }
    },

    async saveConfig() {
      if (
        !this.formData.header &&
        !this.formData.alphanumericPrefix &&
        !this.formData.alphanumericSuffix
      ) {
        alert(this.$t("views.settings.error_empty_blocks"));
        return;
      }

      try {
        await saveTripNumberConfig(this.axios, this.formData, this.idCompanyParent);
        this.$emit("save", this.formData);
        this.loadTripNumberConfig();
        this.loadConfigTrip();
      } catch (error) {
        console.error("Error saving config:", error);
      }
    },
    resetForm() {
      this.formData = {
        header: '',
        alphanumericPrefix: '',
        alphanumericSuffix: '',
        fullTripNumber: '',
      };
    },
  },
  mounted() {
    this.loadTripNumberConfig();
    this.loadConfigTrip();
  },
};
</script>


<style scoped>
.v-card-title {
  background-color: #fff !important;
}

.text-color {
  color: #0b0045 !important;
}
</style>